import { Localized } from "@fluent/react"
import { Box, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { CancelButton } from "../../../app/components/CancelButton";
import { CopyToClipboardButton } from "../../../app/components/CopyToClipboardButton";
import { DownloadButton } from "../../../app/components/DownloadButton";
import { loadHelpArticles, selectAllHelpArticles, selectHelpArticles } from "./helpArticlesSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { If } from "../../../app/If";

interface GenerateCodeHelpArticlesDialogProps {
    onCancel: () => void;
}

export const GenerateCodeHelpArticlesDialog: React.FC<GenerateCodeHelpArticlesDialogProps> = ({ onCancel }) => {
    const { loaded } = useAppSelector(selectHelpArticles)
    const articles = useAppSelector(selectAllHelpArticles)
    const dispatch = useAppDispatch()
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [code, setCode] = useState("");

    useEffect(() => {
        if (!loaded) {
            setIsLoading(true);
            dispatch(loadHelpArticles())
        } else {
            const inserts = articles?.map(s => {
                return `UPDATE [dbo].[SysHelpArticle] SET Title = '${s.title}', Description = '${s.description}', Location = '${s.location}', Description_EN = '${s.description_EN}', Title_EN = '${s.title_EN}' WHERE Id = '${s.id}';\nINSERT INTO [dbo].[SysHelpArticle] ([Id], [Title], [Description], [Location], [Description_EN], [Title_EN]) SELECT '${s.id}', '${s.title}', '${s.description}', '${s.location}', '${s.description_EN}', '${s.title_EN}') WHERE NOT EXISTS (SELECT 1 FROM [dbo].[SysHelpArticle] WHERE Id = '${s.id}');`
            }).join("\n\n");

            setCode(inserts ?? "");
            setIsLoading(false);
        }
    }, [dispatch, loaded, articles])

    return (
        <>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="default-company-settings-generate-script">
                        <span>_Wygeneruj skrypt</span>
                    </Localized>
                    <div>
                        <DownloadButton name="migration_helpArticles" value={code} />
                        <CopyToClipboardButton value={code} />
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <If condition={!isLoading} otherwise={<CircularProgress/>}>
                    <Typography
                        component="pre"
                        sx={{
                            padding: 2,
                            fontFamily: "monospace"
                        }}
                    >
                    {`${code}`}
                    </Typography>
                </If>
            </DialogContent>
            <DialogActions>
                <CancelButton loading={false} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}